export enum Pages {
    main,
    report,
    chart,
    chartDisplay
}

export enum ChartType {
    report = 'report',
    chart = 'chart'
    // widget = 'widget'
}

export const isMenuItemWithFeaturePromotion = (ename: string): boolean => {
    return menuItemsWithFeaturePromtion.includes(ename);
};

export const menuItemsWithFeaturePromtion = [
    'ALINEREP',
    'ASSEMBLYREP',
    'ASSETREP',
    'BOOKREP',
    'CPROFREP',
    'CUSTCAMPAIGNSREP',
    'CUSTNOTESREP',
    'CUSTREP',
    'FNINVSALESREP',
    'FNMATRIXREP',
    'FOBDOCREP',
    'FOBORDERSREP',
    'FORECASTREP',
    'FTRANSREP',
    'INVOICEREC',
    'INVOICEREP',
    'JOBSREP',
    'LEADSREP',
    'LEASINGREP',
    'LOANSREP',
    'LOGTRANSREP',
    'MONTHHOURSREP',
    'MONTHSALARIESREP',
    'ORDERSREP',
    'PARTSREP',
    'PINVOICEREP',
    'PORDERSREP',
    'PROJREP',
    'SALARYTRANSREP',
    'PARTCSALESRATEREPSTREP',
    'SALESRATEWARHSREP',
    'SALESREP',
    'SERNUMBERSREP',
    'SERVCALLREP',
    'SERVREP',
    'STARGETINVREP',
    'STARGETORDREP',
    'SUPREP',
    'TAXASSETREP',
    'USERSBREP',
    'USERSCREP',
    'WARHSBALCREP',
    'WARHSBALREP',
    'WMSREP',
    'WWWREPORTS'
];

export const monitorTransactionValues = {
    // main Icon
    AnalyticsIcon: 'AnalyticsIcon',

    // Promotion pop-up message
    AnalyticsPromoYes: 'AnalyticsPromoYes',
    AnalyticsPromoOk: 'AnalyticsPromoOk',
    AnalyticsPromoX: 'AnalyticsPromoX',

    // main section:
    AnalyticsMainX: 'AnalyticsMainX',
    AnalyticsMainNew: 'AnalyticsMainNew',
    AnalyticsMainHelp: 'AnalyticsMainHelp',
    AnalyticsMainEdit: 'AnalyticsMainEdit',
    AnalyticsMainRun: 'AnalyticsMainRun',

    // new report dialog:
    AnalyticsNewX: 'AnalyticsNewX',
    AnalyticsNewHelp: 'AnalyticsNewHelp',
    AnalyticsNewOK: 'AnalyticsNewOK',
    AnalyticsNewCancel: 'AnalyticsNewCancel',

    // new Chart dialog:
    ChartNewX: 'ChartNewX',
    ChartNewHelp: 'ChartNewHelp',
    ChartNewOK: 'ChartNewOK',
    ChartNewCancel: 'ChartNewCancel',

    // report settings area
    AnalyticsSetX: 'AnalyticsSetX',
    AnalyticsSetHelp: 'AnalyticsSetHelp',
    AnalyticsSetSave: 'AnalyticsSetSave',
    AnalyticsSetRun: 'AnalyticsSetRun',
    AnalyticsSetAddFields: 'AnalyticsSetAddFields',
    AnalyticsSetAddExpression: 'AnalyticsSetAddExpression',
    AnalyticsSetChangesYes: 'AnalyticsSetChangesYes',
    AnalyticsSetChangesNo: 'AnalyticsSetChangesNo',

    // select field dialog:
    AnalyticsSelectX: 'AnalyticsSelectX',
    AnalyticsSelectHelp: 'AnalyticsSelectHelp',
    AnalyticsSelectSave: 'AnalyticsSelectSave',
    AnalyticsSelectCancel: 'AnalyticsSelectCancel',
    AnalyticsSelectChangesYes: 'AnalyticsSelectChangesYes',
    AnalyticsSelectChangesNo: 'AnalyticsSelectChangesNo',

    AnalyticsBaseForm: 'AnalyticsBaseForm',

    // vizualization
    AnalyticsChart: 'AnalyticsChart',
    AnalyticsChartType: 'AnalyticsChartType',
    AnalyticsExplainReport: 'AnalyticsExplainReport',
    AnalyticsExplainReportHelp: 'AnalyticsExplainReportHelp',
    AnalyticsRunChart: 'AnalyticsRunChart',
    AnalyticsSaveChart: 'AnalyticsSaveChart'
};

export const chartConfigInfo = {
    baseForm: 'baseForm',
    chartName: 'chartName',
    subTitle: 'subTitle',
    explanatoryReport: 'explanatoryReport',
    type: 'type',
    active: 'active',
    share: 'share',
    multiCompany: 'multiCompany',
    xAxis: 'xAxis',
    yAxis: 'yAxis',
    topX: 'topX',
    bubbleConfig: 'bubbleConfig',
    series: 'series',
    scales: 'scales'
};

export const initialChartInfo = {
    baseForm: null,
    chartName: '',
    subTitle: '',
    explanatoryReport: null,
    active: false,
    share: false,
    type: '',
    xAxis: null,
    yAxis: null,
    topX: null,
    scales: null
};
export const bubbleConfigInfo = {
    minX: 'minX',
    maxX: 'maxX',
    minY: 'minY',
    maxY: 'maxY',
    category: 'category',
    zBubbleSize: 'zBubbleSize'
};

export const scalesFormName = 'SCALES';

export const defaultTopXValues = {
    single: '10',
    multi: '3'
};

export const defaultExpReportItem = {
    label: '--',
    RootNodeId: null,
    Title: '--',
    value: null
};

export const IsCompany = 'IsCompany';
export const IsExpression = 'IsExpression';

export const FieldsSelectDlgID = 'fields-select-dialog';

export const CALCULATED_FORMS_EXECS = [
    7729, 10301, 15021, 12516, 13102, 4523, 4738, 7739, 12729, 13873, 78998
];
